export const PASSWORD_RULES = {
  MIN_LENGTH: 8,
  SPECIAL_CHARS: "!@#$%^&*()_+-={}[]|\\:;\"'<>,.?/~`",
};

export const VALIDATION_MESSAGES = {
  PASSWORD_MATCH: "Password Match",
  MIN_LENGTH: "Add at least 8 characters",
  LOWERCASE: "Add a lowercase letter",
  UPPERCASE: "Add an uppercase letter",
  NUMBER: "Add a number",
  SPECIAL: "Add a special character (!@#$%^&*_+)",
  REQUIRED_FIELDS: "Please fill in all required fields",
  INVALID_EMAIL: "Please enter a valid email address",
};

export const INITIAL_VALIDATION_STATE = {
  passwordMatch: false,
  minLength: false,
  hasLower: false,
  hasUpper: false,
  hasNumber: false,
  hasSpecial: false,
};
